import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Modal, Button, Stack, TextField, Checkbox, Typography, MenuItem } from '@mui/material';
import { updateGenericData } from './api';
import { cores, labelCampoEscuro } from '../styles/styleUtils';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50vw',
  height: '95vh',
  '@media screen and (max-width: 600px)': {
    width: '50vw',
    height: '95vh',
  },
  bgcolor: 'transparent',
  border: `1px solid ${cores.chumbo}`, borderTop: `4px solid ${cores.laranja}`,
  boxShadow: 24,
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  background: `linear-gradient(180deg, ${cores.painelTopo} 0%, ${cores.painelBase} 100%)`,
  alignItems: 'center',
  justifyContent: 'center',
};

const unidades = ['m²', 'kW', 'KVA', 'kWp', 'A', 'un', 'KVAr', 'dia', 'semana', 'mês'];
const tipos = ['único', 'recorrente'];
const periodicidades = ['diária', 'semanal', 'quinzenal', 'mensal'];

const campo = { width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 };

// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const ModalAddServico = React.forwardRef((props, ref) => {
  const [data, setData] = useState(props.dataSelected);

  const handleChange = (e) => {
    setData({ ...data, [e.target.id]: e.target.value });
  };

  const saveData = async () => {
    await updateGenericData('servico', { ...data, valor: Number(data.valor) || 0 });
    props.onConfirm();
  };

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} gap={2}>
        <TextField
          id="nome"
          label="Nome"
          variant="outlined"
          value={data?.nome || ''}
          onChange={handleChange}
          sx={campo}
        />

        <TextField
          type="number"
          id="valor"
          label="Valor Unitário (R$)"
          variant="outlined"
          value={data?.valor ?? ''}
          onChange={handleChange}
          sx={campo}
        />

        <TextField
          select
          id="unidade"
          label="Unidade"
          value={data?.unidade || ''}
          onChange={(e) => setData({ ...data, unidade: e.target.value })}
          sx={campo}
        >
          {unidades.map((u) => (
            <MenuItem key={u} value={u}>{u}</MenuItem>
          ))}
        </TextField>

        <TextField
          select
          id="tipo"
          label="Tipo"
          value={data?.tipo || 'único'}
          onChange={(e) => setData({ ...data, tipo: e.target.value, ...(e.target.value === 'único' && { periodicidade: '' }) })}
          sx={campo}
        >
          {tipos.map((t) => (
            <MenuItem key={t} value={t}>{t}</MenuItem>
          ))}
        </TextField>

        {data?.tipo === 'recorrente' && (
          <TextField
            select
            id="periodicidade"
            label="Periodicidade"
            value={data?.periodicidade || ''}
            onChange={(e) => setData({ ...data, periodicidade: e.target.value })}
            sx={campo}
          >
            {periodicidades.map((p) => (
              <MenuItem key={p} value={p}>{p}</MenuItem>
            ))}
          </TextField>
        )}

        <Stack direction={'row'}>
          <Checkbox
            checked={data?.ativo ?? true}
            onChange={() => setData({ ...data, ativo: !data.ativo })}
            inputProps={{ 'aria-label': 'controlled' }}
            sx={{ color: 'rgba(255,255,255,0.7)', '&.Mui-checked': { color: cores.laranja } }}
          />
          <Typography mt={1} sx={{ color: cores.textoClaro }}>Ativo</Typography>
        </Stack>
        <Stack direction={'row'} justifyContent={'space-between'} gap={20} mt={0}>
          <Button variant="outlined" onClick={props.onClose} color="error">
            {' '}
            Cancelar
          </Button>
          <Button variant="contained" color="success" onClick={saveData}>
            Salvar
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
});

ModalAddServico.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  dataSelected: PropTypes.object,
};

export default ModalAddServico;